module.exports = __webpack_public_path__ + "img/img_market_con_b.0712804b.png";